export default "__VITE_ASSET__f9835955__"